/* @ngInject */
const utilsMath = () => {
  const self = {}

  self.min = (a, b) => {
    return a < b ? a : b
  }

  self.max = (a = 0, b = 0) => {
    return a > b ? a : b
  }

  self.random = () => {
    return Math.random()
  }

  return self
}

export default utilsMath



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/utils/utils.math.js